module.exports = __webpack_public_path__ + "static/media/nba-logoman-word-white.9470e2d5.svg";